<template>
    <div>
       <v-card>
        <v-card-title>{{ $t('Support request list') }}</v-card-title>
        <v-card-text>
         <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">{{ $t('Date') }}</th>
                  <th class="text-left">{{ $t('Message') }}</th>
                  <th class="text-left">{{ $t('Documents') }}</th>
                  <th/>
                </tr>
              </thead>
              <tbody>
                <template v-if="tickets.length">
                  <tr v-for="(ticket, index) in tickets" :key="`ticket-${index}`">
                    <td>{{ utcToLocalDateTimeLess(ticket.created_at) }}</td>
                    <td>{{ ticket.message }}</td>
                    <td>
                      <single-file-item v-for="file in ticket.files"
                              :key="`file-${file.id}`"
                              :file="file"/>
                    </td>
                    <td>
                      <v-btn color="primary" small :to="{ name: 'tickets.detail', params: {id:ticket.id} }">
                        {{ $t('View') }}
                      </v-btn>
                    </td>
                  </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td colspan="4">{{ $t('No data') }}</td>
                    </tr>
                  </template>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
       </v-card>
    </div>
</template>

<script>
import { utcToLocalDateTimeLess } from '@utils'
import SingleFileItem from '@/components/SingleFileItem'

export default {
  name: 'SuportRequestList',
  props: {
    tickets: {
      type: Array,
      required: true
    }
  },
  components: {
    SingleFileItem
  },
  methods: {
    utcToLocalDateTimeLess
  }
}
</script>
